'use strict';

const Flatpickr = require('flatpickr');
const first = require('lodash/first');
const last = require('lodash/last');

class CalendarView {
  constructor(options) {
    const { collection, selection } = options;
    this.options = { selection };
    this.collection = collection;
    this.collection.on('request', this.updateCalendar, this);
    this.collection.on('sync', this.updateCalendar, this);
    this.collection.on('reset', this.updateCalendar, this);
    this.handleSelection = this.handleSelection.bind(this);
  }

  render() {
    if (!this.calendar) {
      const calendarContainer = document.createElement('div');
      const rootElement = document.createElement('div');
      rootElement.appendChild(calendarContainer);
      this.$el = $(rootElement); // necessary until jQuery is removed
      const options = this.getCalendarOptions();
      this.calendar = this.createCalendar(calendarContainer, options);
      this.calendar.calendarContainer.classList.add('calendar');
      this.calendar.jumpToDate(options.startMonth);
    }
  }

  updateCalendar() {
    if (this.calendar) {
      const dates = this.getDates();
      this.calendar.set('enable', dates);
      if (!this.options.selection) this.calendar.clear();
      const firstDate = first(dates);
      if (firstDate) {
        this.calendar.jumpToDate(firstDate);
      }
    }
  }

  handleSelection(selectedDate, dateString) {
    if (!dateString) return;
    const dateModel = this.collection.find(model => model.toString() === dateString);
    this.options.selection = dateModel;
    if (this.events && this.events.select) {
      // mimic Backbone.Events.trigger
      const { callback, context } = this.events.select;
      callback.call(context, dateModel, this);
    }
  }

  getDates() {
    return this.collection.map(model => model.toString());
  }

  getCalendarOptions() {
    const dates = this.getDates();
    let startMonth = null;
    if (this.options.selection) {
      startMonth = this.options.selection.toString();
    } else if (first(dates)) {
      startMonth = first(dates).toString();
    }

    return {
      inline: true,
      disableMobile: true,
      enable: dates,
      minDate: first(dates),
      maxDate: last(dates),
      onChange: this.handleSelection,
      startMonth,
      monthSelectorType: 'static',
    };
  }

  // mimic Backbone.Events.on
  on(eventName, triggerCallback, context) {
    this.events = this.events || {};
    this.events[eventName] = {
      callback: triggerCallback,
      context,
    };
  }

  createCalendar(selector, options) {
    Flatpickr.l10ns.default.weekdays.shorthand = [
      window.I18n.t('.modules.glive_booking_redesign.calendar.sunday_abbreviation'),
      window.I18n.t('.modules.glive_booking_redesign.calendar.monday_abbreviation'),
      window.I18n.t('.modules.glive_booking_redesign.calendar.tuesday_abbreviation'),
      window.I18n.t('.modules.glive_booking_redesign.calendar.wednesday_abbreviation'),
      window.I18n.t('.modules.glive_booking_redesign.calendar.thursday_abbreviation'),
      window.I18n.t('.modules.glive_booking_redesign.calendar.friday_abbreviation'),
      window.I18n.t('.modules.glive_booking_redesign.calendar.saturday_abbreviation'),
    ];
    return Flatpickr(selector, options);
  }
}

module.exports = CalendarView;
